import styled from 'styled-components';
import { localizeInteger } from 'utils/i18nHelpers';
import { Cell } from './Cell';

type CountCellProps = {
  count: number;
  rowIndex: number;
};

const Wrapper = styled.div`
  align-self: flex-end;
`;

export const CountCell = ({ count, rowIndex }: CountCellProps) => (
  <Cell data-test="audience-count-value" columnId="count" $rowIndex={rowIndex}>
    <Wrapper>{localizeInteger(count)}</Wrapper>
  </Cell>
);
